

































































































































































































































import { Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { ICampaign, Campaign, CAMPAIGN_VALIDATION_RULES, CampaignType, IFormatParameter, FormatParameter, IFormat, IFormatVersion, ICampaignParameter, CampaignParameter, ICanvasContent, ICanvasContentParameter, CanvasContentParameter, CanvasContent, ICanvasBannerPlaceholder } from '@models'
import FormatVersionService from '../../services/FormatVersionService';
import FormatParameterService from '../../services/FormatParameterService';
import ComponentBase from '../../components/ComponentBase'
import { cloneDeep } from 'lodash';


@Component
export default class UpgradeFormatVersion extends ComponentBase {

  @Prop({ type: Object as () => ICampaign }) campaign: ICampaign;

  newCampaign: ICampaign = null;
  latestFormatVersion: IFormatVersion;
  specificFormatVersion: IFormatVersion;

  message: string = "";

  latestFormatVersionParameters: IFormatParameter[] = [];
  specificFormatVersionParameters: IFormatParameter[] = [];

  unchangedParameters: ICampaignParameter[] = [];
  newParameters: ICampaignParameter[] = [];
  removedParameters: ICampaignParameter[] = [];

  newCampaignParameters: ICampaignParameter[] = [];

  latestCanvanContentFormatVersions: IFormatVersion[] = [];
  specificCanvasContentFormatVersions: IFormatVersion[] = [];

  newCanvasPlaceholders: ICanvasBannerPlaceholder[] = [];
  updatedCanvasContent: ICanvasContent[] = [];
  removedCanvasContent: ICanvasContent[] = [];
  removedCanvasContentParams: Map<string, ICanvasContentParameter[]> = new Map<string, ICanvasContentParameter[]>();

  getUpdatedParametersForCanvasContent(canvasContent: ICanvasContent): ICanvasContentParameter[] {
    let result = [];

    result = this.latestCanvanContentFormatVersions.find(x => x.formatId == canvasContent.formatVersion.formatId)?.formatParameters.filter(x => x.isReplaceableValue).map(x => {
      let currentParam = canvasContent.parameters.find(p => p.tag === x.tag);
      let newParam: ICanvasContentParameter = null;
      if (currentParam) {
        newParam = cloneDeep(currentParam);
        newParam.id = undefined;
        newParam.formatParameterId = x.id;
      } else {
        newParam = new CanvasContentParameter({
          campaignId: this.campaign.id,
          canvasContentId: canvasContent.id,
          formatParameterId: x.id,
          formatParameter: x,
          tag: x.tag,
          value: x.value
        });
        newParam.formatParameter.formatVersion = this.latestCanvanContentFormatVersions.find(y => y.id === x.formatVersionId);
      }
      return newParam;
    });

    return result;
  }

  getRemovedParametersForCanvasContent(canvasContent: ICanvasContent): IFormatParameter[] {
    let result = [];

    let latestFormatVersion = this.latestCanvanContentFormatVersions.find(x => x.formatId === canvasContent.formatVersion.formatId);

    result = this.campaign.canvasContent.find(x => x.bannerPlaceholder.tag === canvasContent.bannerPlaceholder.tag).parameters.filter(x => !latestFormatVersion.formatParameters.find(y => y.tag === x.tag));
    return result;
  }

  argumentsAreValid() {
    return this.campaign && this.campaign.formatId && this.campaign.formatVersionId;
  }

  close() {
    this.$emit('cancel');
  }

  upgrade() {
    this.$emit('upgrade', this.newCampaign);
  }

  formValid: boolean = true;

  mustAcceptDeletion = value => !!value || "";

  getDescription(tag: string) {
    return this.latestFormatVersionParameters.find(fp => fp.tag === tag)?.description ||
      this.specificFormatVersionParameters.find(fp => fp.tag === tag)?.description ||
      tag;
  }

  getCanvasContentParamDescription(item: ICanvasContentParameter) {
    return item.formatParameter.description;
  }

  getDisplayValue(value: string) {
    let displayValue: string = value;
    if (value) {
      try {
        let obj = JSON.parse(value);
        if (obj.UploadedFilename) {
          displayValue = obj.UploadedFilename;
        }
      } catch (e) { }
    }
    return displayValue;
  }

  isNew(parameter: CampaignParameter) {
    let foundParameter =
      this.specificFormatVersionParameters.find(fp => fp.tag === parameter.tag);
    return !!!foundParameter;
  }

  isNewCanvasContentParam(parameter: CampaignParameter) {
    let foundParameter =
      this.specificCanvasContentFormatVersions.find(x => x.formatId === parameter.formatParameter.formatVersion.formatId)?.formatParameters.find(x => x.tag === parameter.tag);;
    return !!!foundParameter;
  }

  async getLastFormatVersion(formatId: string): Promise<IFormatVersion> {
    let formatVersion: IFormatVersion = null;
    try {
      const response = await FormatVersionService.getLastFormatVersion(formatId);
      if (response.status === 200) {
        formatVersion = response.data;
      }
      else {
        console.error(`Could not load last format version of format with id ${formatId}`);
      }
    } catch (e) {
      console.error(`Could not load last format version of format with id ${formatId}`, e);
    }

    return formatVersion;
  }

  async getSpecificFormatVersion(formatVersionGuid: string): Promise<IFormatVersion> {
    let formatVersion: IFormatVersion = null;
    try {
      const response = await FormatVersionService.getSpecificFormatVersion(formatVersionGuid);
      if (response.status === 200) {
        formatVersion = response.data;
      }
      else {
        console.error(`Could not load format version with id ${formatVersionGuid}`);
      }
    } catch (e) {
      console.error(`Could not load format version id ${formatVersionGuid}`, e);
    }

    return formatVersion;
  }

  async getFormatVersionParameters(formatVersionGuid: string): Promise<IFormatParameter[]> {
    let formatParameters: IFormatParameter[] = null;
    try {
      const response = await FormatParameterService.getFormatParameters(formatVersionGuid);
      if (response.status === 200) {
        formatParameters = response.data;
      }
      else {
        console.error(`Could not load format parameters for format version with id ${formatVersionGuid}`);
      }
    } catch (e) {
      console.error(`Could not load format parameters for format version with id ${formatVersionGuid}`, e);
    }

    return formatParameters.filter(x => x.isReplaceableValue) || [];
  }

  async created() {
    this.isLoading = true;

    // Initialize
    this.unchangedParameters = new Array<ICampaignParameter>();
    this.newParameters = new Array<ICampaignParameter>();
    this.removedParameters = new Array<ICampaignParameter>();
    this.latestCanvanContentFormatVersions = new Array<IFormatVersion>();
    this.specificCanvasContentFormatVersions = new Array<IFormatVersion>();

    // Get format versions to compare
    this.latestFormatVersion = await this.getLastFormatVersion(this.campaign.formatId);
    this.specificFormatVersion = await this.getSpecificFormatVersion(this.campaign.formatVersionId);

    // Check it differs from the formatversion of the campaign - if not there's no need to continue
    if ((!this.latestFormatVersion?.id || !this.specificFormatVersion?.id) && this.latestFormatVersion.id === this.specificFormatVersion.id) {
      this.message = "You're allready using the latest version";
      return;
    }

    // Get format parameters for both versions
    this.latestFormatVersionParameters = await this.getFormatVersionParameters(this.latestFormatVersion.id);
    this.specificFormatVersionParameters = await this.getFormatVersionParameters(this.specificFormatVersion.id);

    // Unchanged parameters
    this.unchangedParameters = this.campaign.parameters
      .filter(cp => this.latestFormatVersionParameters.find(fp => fp.tag === cp.tag));



    this.unchangedParameters.forEach(unchangedParam => {
      const latestFormatVersionParamId = this.latestFormatVersionParameters.find(latestFormatVersionParam => latestFormatVersionParam.tag == unchangedParam.tag).id;
      unchangedParam.formatParameterId = latestFormatVersionParamId;
    });

    // Added parameters
    this.newParameters = this.latestFormatVersionParameters
      .filter(fp => !this.campaign.parameters
        .find((cp) => cp.tag === fp.tag && fp.isReplaceableValue)
      )
      .map((fp) => {
        let newCampaignParameter = new CampaignParameter();
        newCampaignParameter.tag = fp.tag;
        newCampaignParameter.value = fp.value;
        newCampaignParameter.campaignId = this.campaign.id;
        newCampaignParameter.formatParameterId = fp.id;
        newCampaignParameter.formatParameter = fp;
        return newCampaignParameter;
      });


    // Deleted parameters
    this.removedParameters = this.campaign.parameters
      .filter(cp => !this.latestFormatVersionParameters
        .find(fp => fp.tag === cp.tag)
      );

    this.newCampaignParameters = [...this.unchangedParameters, ...this.newParameters];

    this.newCanvasPlaceholders = this.latestFormatVersion.canvasBannerPlaceholders.filter(x => !this.campaign.canvasContent.find(y => y.bannerPlaceholder.tag === x.tag));
    this.removedCanvasContent = this.campaign.canvasContent.filter(x => !this.latestFormatVersion.canvasBannerPlaceholders.find(y => y.tag === x.bannerPlaceholder.tag));
    const updatedCanvasContentArr = cloneDeep(this.campaign.canvasContent.filter(x => this.latestFormatVersion.canvasBannerPlaceholders.find(y => y.tag === x.bannerPlaceholder.tag)));

    for (let i = 0; i < updatedCanvasContentArr.length; i++) {
      let latestFormatVersion = await this.getLastFormatVersion(updatedCanvasContentArr[i].formatVersion.formatId);
      updatedCanvasContentArr[i].formatVersionId = latestFormatVersion.id;

      let specificFormatVersion = await this.getSpecificFormatVersion(this.campaign.canvasContent.find(x => x.bannerPlaceholder.tag === updatedCanvasContentArr[i].bannerPlaceholder.tag)?.formatVersionId);
      this.latestCanvanContentFormatVersions.push(latestFormatVersion);
      this.specificCanvasContentFormatVersions.push(specificFormatVersion);
      const updatedParams = this.getUpdatedParametersForCanvasContent(updatedCanvasContentArr[i]);
      const removedParams = this.getRemovedParametersForCanvasContent(updatedCanvasContentArr[i]);
      const newPlaceholder = this.latestFormatVersion.canvasBannerPlaceholders.find(x => x.tag === updatedCanvasContentArr[i].bannerPlaceholder.tag);
      updatedCanvasContentArr[i].bannerPlaceholderId = newPlaceholder.id;
      updatedCanvasContentArr[i].parameters = updatedParams;
      updatedCanvasContentArr[i].formatVersion = latestFormatVersion;
      updatedCanvasContentArr[i].bannerPlaceholder = newPlaceholder;
      updatedCanvasContentArr[i].id = undefined;
      this.removedCanvasContentParams.set(this.campaign.canvasContent[i].bannerPlaceholder.tag, removedParams);
    }
    this.updatedCanvasContent = [...updatedCanvasContentArr];

    let clonedCampaign: ICampaign = cloneDeep(this.campaign);
    clonedCampaign.formatVersion = this.latestFormatVersion;
    clonedCampaign.formatVersionId = this.latestFormatVersion.id;
    clonedCampaign.parameters = [...this.unchangedParameters, ...this.newParameters];
    clonedCampaign.canvasContent = [...this.updatedCanvasContent];

    this.newCampaign = clonedCampaign;

    this.isLoading = false;
  }
}
